import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Strong } from '../../../components/atoms/Strong/Strong';

export function PreviewCaption({ fileName }: { fileName: string }) {
  const { t } = useSonTranslation('ImageUpload');
  return (
    <figcaption className="image-upload__image-description">
      <Strong>
        {/* keep whitespace here! */}
        {t('previewImage')}:{' '}
      </Strong>
      <span className="image-upload__filename">{fileName}</span>
    </figcaption>
  );
}
